import HrCalendarPg from "../HR/HrCalendarPg";

function EmpCalendarPage() {
  return <HrCalendarPg readOnly />;
}

export default EmpCalendarPage;
